import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Field } from 'formik';
import { Form, Row, Col, Button, FormGroup, Label } from 'reactstrap';
import * as Yup from 'yup';
import { CardElement, injectStripe } from 'react-stripe-elements';
import moment from 'moment';

import { renderField } from 'core/utils/formik';

const trailExpDate = moment().add(30, 'days').format('LL');

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

const SignupForm = (props) => {
  const { handleSubmit, isValid, isSubmitting } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Field
        name="account.name"
        component={renderField}
        label="Company Name"
        placeholder="Company Name"
        required
      />

      <Row>
        <Col md={6}>
          <Field
            name="user.first_name"
            component={renderField}
            label="First Name"
            placeholder="John"
            required
          />
        </Col>

        <Col md={6}>
          <Field
            name="user.last_name"
            component={renderField}
            label="Last Name"
            placeholder="Smith"
            required
          />
        </Col>
      </Row>

      <Field
        name="user.email"
        type="email"
        component={renderField}
        label="Email"
        placeholder="email@example.com"
        required
      />

      <Field
        name="user.password"
        type="password"
        component={renderField}
        label="Password"
        placeholder="********"
        required
      />

      <Field
        name="creditCardComplete"
        render={({ field, form }) => {
					const { name } = field;

          return (
            <FormGroup>
              <Label className="required">Credit Card Details</Label>
              <CardElement
                style={{ base: { fontSize: '16px' } }}
                className="form-control"
                onChange={({ complete }) => {
                  form.setFieldValue(name, complete);
                  form.setFieldTouched(name, true);
                }}
              />

              <small className="form-text text-muted">
                ** Your card will not be charged until after your 30-day trial, which ends on {trailExpDate}.
              </small>

              <small className="form-text text-muted">
                Your subscription will automatically renew every 30 days at a rate of $39.95, but you can cancel anytime.
              </small>
            </FormGroup>
          );
        }}
      />

      <Button
        type="submit"
        color="success"
        disabled={!isValid || isSubmitting}
      >
        Start Your Free Trial
      </Button>
    </Form>
  );
};

SignupForm.propTypes = propTypes;

export default injectStripe(withFormik({
  mapPropsToValues: () => ({
    account: {
      name: '',
    },
    user: {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
    },
    creditCardComplete: false,
  }),
  validationSchema: Yup.object().shape({
    account: Yup.object().shape({
      name: Yup.string().required('Required'),
    }),
    user: Yup.object().shape({
      first_name: Yup.string().required('Required'),
      last_name: Yup.string().required('Required'),
      email: Yup.string().email('Invalid email').required('Required'),
      password: Yup.string().min(8).required('Required'),
    }),
    creditCardComplete: Yup.boolean().oneOf([true]),
  }),
  isInitialValid: false,
  handleSubmit: (formValues, formikBag) => {
    // const { setSubmitting, setErrors, props: { onSubmit, stripe } } = formikBag;

    // stripe.createToken().then(({ token }) => {
    //   onSubmit({
    //     values: Object.assign({ token: token.id }, formValues),
    //     setSubmitting,
    //     setErrors,
    //   });
    // });
  },
})(SignupForm));



// WEBPACK FOOTER //
// ./src/features/Signup/SignupForm.js